import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ClearFiltersButton } from './ClearFiltersButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketListEmptyState({
  error,
  hasActiveFilters,
  headingTypography = 'heading-200',
  clearFiltersScreen = 'ticket-listings'
}) {
  if (error) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      padding: "400",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: headingTypography,
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.loadError"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.loadErrorHelp"
        })
      })]
    });
  }
  if (hasActiveFilters) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      padding: "400",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: headingTypography,
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.noResults"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.noResultsHelp"
        })
      }), /*#__PURE__*/_jsx(ClearFiltersButton, {
        screen: clearFiltersScreen
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    padding: "400",
    gap: "300",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: headingTypography,
      color: "text-core-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.emptyInbox"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.emptyInboxHelp"
      })
    })]
  });
}